import { versions } from "node:process";
export const getRuntimeUserAgentPair = () => {
    const runtimesToCheck = ["deno", "bun", "llrt"];
    for (const runtime of runtimesToCheck) {
        if (versions[runtime]) {
            return [`md/${runtime}`, versions[runtime]];
        }
    }
    return ["md/nodejs", versions.node];
};
